// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__69r6G","children":"styles_children__YRklb"};